const scopesEnglishMap = {
  'account.read': 'Access your account information',
  'openid': 'Access your account information',
  'app.read': 'Access available OAuth 2.0 clients',
  'app.write': 'Create and manage OAuth 2.0 clients',
  'app.all': 'Access, create and manage OAuth 2.0 Client',
  'enrollment.read': 'Access to enrollments',
  'enrollment.write': 'Manage enrollments',
  'enrollment.all': 'Access and manage enrollments',
  'lo.read': 'Access content',
  'lo.write': 'Manage content',
  'lo.all': 'Access and manage content',
  'portal.read': 'Access this portal',
  'portal.write': 'Manage this portal',
  'portal.all': 'Access and manage this portal',
  'group.read': 'Access user groups',
  'group.write': 'Manage user groups',
  'group.all': 'Access and manage user groups',
  'user.login': 'Generate login links for other users in your portal',
  'user.login.me': 'Generate login links for your user',
  'user.read': 'Access user profile',
  'user.write': 'Manage user profile',
  'user.all': 'Access and manage user profile',
  'webhook.read': 'Access to your webhook subscription configuration',
  'webhook.write': 'Modify webhook subscription configuration',
  'webhook.all': 'Access and modify webhook subscription configuration',
  'internal.proxy': 'Proxy requests to internal services',
  'lo.launch': 'Generate play links for other users in your portal',
  'wallet.organization.read': 'Access Go1Pay organization resources',
  'wallet.organization.write': 'Manage Go1Pay organization resources',
  'wallet.organization.all': 'Access and manage Go1Pay organization resources',
  'wallet.budget.read': 'Access Go1Pay budget resources',
  'plan.read': 'Access customer subscription plans',
  'plan.write': 'Manage customer subscription plans'
};

// use scope key to get the english value
export default function MapScopesToEnglish(scopes) {
  return scopes.map(scope => scopesEnglishMap[scope]).filter(v => v); // ignore scopes that do not have english mappings
}



// WEBPACK FOOTER //
// ./src/utils/MapScopesToEnglish.js